import config from '../config';

export const isProd = () => config.ENV === 'prod';
